"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

var warnOnce = require("@atlaskit/ds-lib/warn-once").default;

warnOnce("The '@atlaskit/icon-priority' package has been deprecated due to its limited usage in Cloud Products. If you depend on '@atlaskit/icon-priority' we recommend self-managing the assets.")

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PriorityLowIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.996 13.861l6.454-3.865a1 1 0 111.027 1.716l-6.97 4.174a1 1 0 01-1.03-.002L4.57 11.71A1 1 0 015.606 10l6.39 3.862z" fill="#0065FF"/></svg>`
}, props));

PriorityLowIcon.displayName = 'PriorityLowIcon';
var _default = PriorityLowIcon;
exports.default = _default;
